import {
  CommunityNavigation,
  LoggedInUser,
  CommunityApp,
} from '@atlassian/learning-components';

import {
  CommunityAnalyticsClient,
  eventType,
} from '@atlassian/community-library';

import {
  getLoginHref,
  getLogoutHref,
  getSignupHref,
  getSwitchHref,
} from '@app/auth';

interface Props {
  isLoggedIn: boolean;
  loggedInUser: LoggedInUser | undefined;
}

export const TopNavigationContents = ({ isLoggedIn, loggedInUser }: Props) => {
  // Auth href utils read window.location.href internally at call time, ensuring the correct
  // page URL is used even on the details page (/release-notes/:id)
  const email = loggedInUser?.email || '';
  const loginHref = getLoginHref(email);
  const logoutHref = getLogoutHref(email);
  const signupHref = getSignupHref(email);
  const switchHref = getSwitchHref();

  return (
    <CommunityNavigation
      currentApp={CommunityApp.APP_UPDATES}
      isLoggedIn={isLoggedIn}
      user={loggedInUser}
      loginHref={loginHref}
      logoutHref={logoutHref}
      signupHref={signupHref}
      switchHref={switchHref}
      onAnalyticsSendEvent={(type, payload) =>
        CommunityAnalyticsClient.sendEvent(
          type as unknown as eventType,
          payload,
        )
      }
      email={loggedInUser?.email}
      showAppUpdates={true}
      showNewMenu={true}
    />
  );
};
